<template>
  <div>
    <carousel :interval="interval" v-if="images.length > 1">
      <slider :index="i" v-for="(image, i) in images" :key="image">
        <ImageC :srcSuffix="image"></ImageC>
      </slider>
    </carousel>
    <div v-else>
      <ImageC v-if="images.length > 0" :srcSuffix="images[0]"></ImageC>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import carousel from './Vuestrap-TemporaryFix/Carousel.vue';
import slider from './Vuestrap-TemporaryFix/Slider.vue';
import ImageC from './ImageC.vue';

export default {
  name: 'CarouselComponent',
  components: {
    carousel,
    slider,
    ImageC,
  },
  props: {
    images: { default: () => [] },
    interval: { default: 0 },
  },
  computed: {
    ...mapState({
      publicURL: (state) => state.app.API_PUBLIC_URL,
    }),
  },
};
</script>

<style lang="scss" scoped>
img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>

<style lang="scss">
img {
  max-width: 100%;
}

.carousel-control span {
  position: absolute;
  top: 50%;
}
</style>
